// extracted by mini-css-extract-plugin
module.exports = {"copy":"featuredVideo_copy__2fQiK"};